var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("Historico de Ventas")]),_c('v-divider'),_c('GChart',{attrs:{"type":"ColumnChart","data":_vm.chartdata}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }